import React from 'react';
import Icon from '../../../components/AppIcon';

const features = [
  { icon: 'BadgeIndianRupee', title: 'Zero Brokerage', desc: 'Connect directly with property owners. No middlemen, no commission — save thousands on every rental.' },
  { icon: 'ShieldCheck', title: 'Verified Listings', desc: 'Every property is reviewed for accuracy. Owner identity and documents are verified before listing goes live.' },
  { icon: 'MessageCircle', title: 'Direct Chat', desc: 'Message owners instantly through our in-app chat. Negotiate terms, ask questions, and schedule visits.' },
  { icon: 'CreditCard', title: 'Secure Payments', desc: 'Pay rent online safely through our payment gateway. Get receipts automatically for every transaction.' },
  { icon: 'MapPin', title: '100+ Cities', desc: 'From metros like Mumbai and Delhi to tier-2 cities like Lucknow and Jaipur — we cover all of India.' },
  { icon: 'Bell', title: 'Instant Alerts', desc: 'Get notified the moment a property matching your preferences is listed. Never miss a good deal.' },
];

const FeatureGrid = () => {
  return (
    <section className="py-10 sm:py-14 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">Why Owners & Tenants Choose Us</h2>
          <p className="text-gray-500 max-w-lg mx-auto">Everything you need for a smooth rental experience, all in one platform</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div key={i} className="border border-gray-200 rounded-xl p-6 hover:border-rose-200 hover:shadow-sm transition group">
              <div className="w-11 h-11 rounded-lg bg-rose-50 flex items-center justify-center mb-4 group-hover:bg-rose-100 transition">
                <Icon name={f.icon} size={22} className="text-rose-500" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1.5">{f.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureGrid;
